export default {
    figures: {
        cad: {
            dialogTitle: 'CAD to Patent Line Art',
            close: 'Close',
            uploadTitle: 'Import 3D File',
            uploadDesc: 'Supports STEP, STP, IGES, IGS, STL, OBJ, PLY, GLTF, GLB',
            selectFile: 'Select File',
            unsupportedFormat: 'Unsupported file format',
            insertSuccess: 'Inserted to figures',
            insertFailed: 'Failed to insert figure',
            insert: 'Save to Figure',
            modeStandard: 'Standard',
            modePatent: 'Patent',
            lineWidth: 'Line Width',
            hatching: 'Hatching',
            hatchingGap: 'Hatching Gap',
            edgeThreshold: 'Edge Threshold',
            clipToggle: 'Clipping Plane',
            clipFlip: 'Flip',
            explodeToggle: 'Explode View',
            explodeUnsupported: 'This model is a single solid and does not support explode view',
            loadingParser: 'Initializing parser...',
            loadingModel: 'Parsing model...',
            loadingGeneric: 'Loading...',
            loadFailed: 'Failed to load: {message}',
        },
        canvas: {
            loading: 'Image refreshing, please wait...',
            aiUpdating: 'AI is editing the figure...',
            emptyTitle: 'Start describing the figure you want',
            emptyDesc: 'Enter a detailed description in the dialog on the right',
            annotationInfo: {
                button: 'Numerals',
                loading: 'Loading…',
                empty: 'No annotation info for this figure',
                numeralHeader: 'Numeral',
                componentHeader: 'Component',
                editHint: 'Click a component name to edit',
                addRow: 'Add numeral',
                addNumeralPlaceholder: 'Numeral (digits)',
                addComponentPlaceholder: 'Component name',
                addComponentReuseHint: 'Already exists; existing name will be used',
                addCancel: 'Cancel',
                addConfirm: 'Add',
                deleteConfirm: 'Remove numeral {numeral} from this figure?',
                deleteCancel: 'Cancel',
                deleteOk: 'Remove',
                errorNumeralFormat: 'Numeral must be digits or digits+letter',
                errorNumeralRequired: 'Numeral is required',
                errorComponentRequired: 'Component name is required',
            },
        },
        annotationConfirm: {
            reconfirmBanner: 'This project already has a confirmed annotation map. You are now in re-adjustment mode.',
            defaultTitle: 'Please confirm the annotation map',
            colNumeral: 'Numeral',
            colFeature: 'Feature (Component)',
            colFigures: 'Applicable Figures',
            colEmbodiment: 'Embodiment',
            colAnchor: 'Annotation Focus',
            figuresEmpty: '(none selected)',
            embodimentPlaceholder: 'e.g. First Embodiment',
            addRow: '+ Add row',
            confirm: 'Confirm & Start Labeling',
            confirmed: 'Confirmed',
            warnNumeralDup: 'Numeral "{numeral}" is duplicated',
            warnComponentDup: 'Feature name "{name}" is duplicated, please verify',
            warnNewRowNoFigure: 'New rows must have at least one applicable figure',
            warnNoFigure: 'No figure selected — will apply to all figures',
            submitHint: 'Annotation map confirmed, {count} items total',
            submitHintNext: '. Start labeling: {figureNo}',
        },
        fineTune: {
            button: 'Fine tune',
            preparing: 'Preparing',
            title: 'Local Fine Tune',
            close: 'Close',
            placeholder: 'Describe how the model should edit the selected area...',
            selectionCount: '{count} cells selected',
            clear: 'Clear',
            addOperation: 'Add',
            submitAll: 'Submit all',
            operationTitle: 'Instruction {index}',
            remove: 'Remove',
        },
        panel: {
            title: 'Figure Editor',
            reset: 'Reset',
            submit: 'Save',
            newFigureGenerated: 'New figure has been generated and added to the thumbnail list. The current figure has unsaved changes, so it has not been automatically switched.',
            unsavedChanges: 'The current figure has unsaved changes. These changes will not be automatically saved after switching. Are you sure you want to continue?',
            unsavedChangesTitle: 'Unsaved Changes',
            continueSwitch: 'Continue',
            cancel: 'Cancel',
            resetConfirmTitle: 'Reset Confirmation',
            resetConfirm: 'Discard current changes and restore to the last saved state?',
            confirmReset: 'Confirm Reset',
            uploadFailed: 'Upload failed: {fileName}',
            renameFailed: 'Rename failed, please try again',
        },
        uploadDialog: {
            title: 'Upload Figure',
            aiGenerate: 'AI Generate',
            aiGenerateDesc: 'Generate professional figures with AI',
            normalUpload: 'Upload File',
            normalUploadDesc: 'Upload image files from local',
            fromFile: 'From Files',
            fromFileDesc: 'Select from uploaded files',
            cadImport: '3D Model Import',
            cadImportDesc: 'Import STEP/STL files and convert to patent drawings',
            editFigure: 'Edit Figure',
        },
        attachmentPicker: {
            title: 'Select Attachment Images',
            subtitle: 'Choose original images from project attachments or images extracted from Word/PDF files',
            addToCanvasSubtitle: 'Click an image to add it to the canvas',
            empty: 'No available images found in this project',
            loadFailed: 'Failed to load attachment images. Please try again later.',
            importFailed: 'Failed to import attachment image. Please try again later.',
            sourcePrefix: 'Source: ',
            tableImage: 'Table Image',
            selectedCount: 'So far, {count} pictures have been selected.',
            cancel: 'Cancel',
            confirm: 'Confirm',
        },
        collapsePanel: 'Collapse',
        exportPdf: 'Export PDF',
        chat: {
            title: 'Hiro',
            historyTitle: 'History',
            newChat: 'New Chat',
            languageLabel: 'Model Output Language',
            welcome: 'Hello! I can help you generate various technical figures. Describe what you need, and I will create professional drawings based on your requirements.',
            suggestedTasksWithFigures: [
                { title: 'Plan Figures', desc: 'Plan and generate patent line-art figures based on patent documents and disclosure', prompt: 'Help me plan the figures' },
            ],
            suggestedTasksNoFigures: [
                { title: 'Generate Figures from Documents', desc: 'Auto-extract technical solutions from existing materials', prompt: 'Please generate figures from the disclosure / claims / specification' },
                { title: 'Optimize Existing Figures', desc: 'Upload existing figures, auto-optimize and fill gaps', prompt: 'Please optimize and complete the existing figures' },
                { title: 'Draw All Figures', desc: 'Describe requirements from scratch, generate a full set', prompt: 'Please help me draw all figures from scratch' },
            ],
            inputPlaceholder: 'Describe the figure you want, enter {\'@\'} to mention resources...',
            mentionResource: 'Mention Resource',
            awaitingGeneration: 'Figure is generating, please wait...',
            fineTunePrompt: {
                targetFigure: 'Target figure: {figureName}',
                targetFileId: 'Target figure file_id: {fileId}',
                gridRule: 'Grid rule: The target figure is divided into a 10x10 grid, rows A-J from top to bottom, columns 1-10 from left to right; A1 is the top-left corner, J10 is the bottom-right corner.',
                editTarget: 'When calling draw_patent_figures, put this file_id into file_ids_to_edit as the edit target.',
                instruction: 'Please only fine-tune the following 10x10 grid areas in target figure "{figureName}", do not modify other figures.',
                selectedCells: '{index}. Selected area: {cells}',
                modifyRequirement: '   Modification: {instruction}',
            },
            history: {
                title: 'History',
                empty: 'No conversation history',
                search: 'Search conversations...',
                rename: 'Rename',
                delete: 'Delete',
                defaultTitle: 'New conversation',
                today: 'Today',
                yesterday: 'Yesterday',
                lastWeek: 'Last week',
                lastMonth: 'Last month',
                older: 'Older',
            },
        },
    },
};
